const record = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);
const strings = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === "string");
const finite = (value: unknown) =>
  typeof value === "number" && Number.isFinite(value) && value >= 0;
const codeFiles = (value: unknown) =>
  record(value) &&
  Object.entries(value).every(
    ([name, code]) =>
      name.length < 250 && typeof code === "string" && code.length <= 1_000_000,
  );

export function assertBackupStructure(value: unknown) {
  if (JSON.stringify(value).length > 10_000_000)
    throw new Error("备份超过 10MB，请拆分后重试");
  if (
    !record(value) ||
    !strings(value.read) ||
    !finite(value.activeSeconds) ||
    !strings(value.days) ||
    !value.days.every((day) => /^\d{4}-\d{2}-\d{2}$/.test(day)) ||
    !record(value.drafts) ||
    !Object.values(value.drafts).every(codeFiles) ||
    !Array.isArray(value.attempts)
  )
    throw new Error("备份字段不合法");
  const ids = new Set<string>();
  for (const attempt of value.attempts) {
    if (
      !record(attempt) ||
      typeof attempt.id !== "string" ||
      ids.has(attempt.id) ||
      typeof attempt.quizId !== "string" ||
      typeof attempt.contentVersion !== "string" ||
      !["full", "retry"].includes(String(attempt.mode)) ||
      !["active", "submitted"].includes(String(attempt.status)) ||
      !finite(attempt.startedAt) ||
      (attempt.deadlineAt !== undefined && !finite(attempt.deadlineAt)) ||
      (attempt.submittedAt !== undefined && !finite(attempt.submittedAt)) ||
      !record(attempt.answers) ||
      !record(attempt.codeDrafts) ||
      !Object.values(attempt.codeDrafts).every(codeFiles) ||
      !strings(attempt.marked) ||
      (attempt.questionIds !== undefined &&
        (!strings(attempt.questionIds) ||
          new Set(attempt.questionIds).size !== attempt.questionIds.length)) ||
      (attempt.currentQuestionId !== undefined &&
        typeof attempt.currentQuestionId !== "string") ||
      !Array.isArray(attempt.results)
    )
      throw new Error("测评记录格式不正确");
    ids.add(attempt.id);
    if (
      Object.values(attempt.answers).some(
        (answer) =>
          typeof answer !== "string" &&
          typeof answer !== "boolean" &&
          answer !== undefined &&
          !strings(answer),
      )
    )
      throw new Error("测评答案格式不正确");
    for (const result of attempt.results) {
      if (
        !record(result) ||
        typeof result.questionId !== "string" ||
        typeof result.correct !== "boolean" ||
        !finite(result.earned) ||
        !finite(result.possible) ||
        Number(result.earned) > Number(result.possible)
      )
        throw new Error("测评分数格式不正确");
      if (
        result.cases !== undefined &&
        (!Array.isArray(result.cases) ||
          !result.cases.every(
            (item) =>
              record(item) &&
              typeof item.id === "string" &&
              typeof item.name === "string" &&
              typeof item.message === "string" &&
              typeof item.passed === "boolean",
          ))
      )
        throw new Error("代码测试记录格式不正确");
    }
  }
}
